// Simple duration formatting and planning helpers used in the DigitalDiscipline UI

export const DIFFICULTY_MULTIPLIERS = {
  easy: 0.8,
  medium: 1,
  hard: 1.3,
  extreme: 1.6,
};

export const REPEAT_PATTERNS = {
  once: { label: 'goals.repeat.once', labelFallback: 'Tek Seferlik', perWeek: 1 },
  daily: { label: 'goals.repeat.daily', labelFallback: 'Günlük', perWeek: 7 },
  weekdays: { label: 'goals.repeat.weekdays', labelFallback: 'Hafta içi', perWeek: 5 },
  weekends: { label: 'goals.repeat.weekends', labelFallback: 'Hafta sonu', perWeek: 2 },
  twice_week: { label: 'goals.repeat.twiceWeek', labelFallback: 'Haftada 2', perWeek: 2 },
};

export function formatDuration(minutes, t = (k, d) => d || k) {
  const m = Math.max(0, Math.round(minutes || 0));
  if (m < 60) return t('duration.minutes', `${m} dk`);
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return t('duration.hours', `${h} s`);
  return t('duration.hoursMinutes', `${h} s ${rem} dk`);
}

export function calculateTotalCommitment(durationMin, difficulty = 'medium', repeatKey = 'once') {
  const base = Math.max(1, Math.round(durationMin || 0));
  const diff = DIFFICULTY_MULTIPLIERS[difficulty] ?? 1;
  const perWeek = REPEAT_PATTERNS[repeatKey]?.perWeek ?? 1;
  // weekly total minutes as a simple proxy for total commitment
  return Math.round(base * diff * perWeek);
}

// Abort risk is a simple heuristic mapping higher commitment to higher risk (0..1)
export function calculateAbortRisk(weeklyMinutes, context = { weekMinutes: 0, abortRate: 0.1 }) {
  const target = Math.max(0, weeklyMinutes || 0);
  // Assume > 600 min/week starts increasing risk more steeply
  const loadFactor = Math.min(1, target / 600);
  const base = context.abortRate ?? 0.1;
  return Math.max(0, Math.min(1, base * 0.5 + loadFactor * 0.7));
}

export function getBalanceAssessment(newGoal, existingGoals = []) {
  // compute distribution among domains including the new goal
  const counts = existingGoals.reduce((acc, g) => {
    const domain = g.domain || 'digital';
    acc[domain] = (acc[domain] || 0) + (g.duration || 0);
    return acc;
  }, {});
  counts[newGoal.domain] = (counts[newGoal.domain] || 0) + (newGoal.duration || 0);

  const values = Object.values(counts);
  if (values.length === 0) return { score: 1, recommendation: 'balanced' };
  const max = Math.max(...values);
  const sum = values.reduce((a, b) => a + b, 0) || 1;
  const concentration = max / sum; // closer to 1 means concentrated in a domain
  const score = Math.max(0, 1 - concentration); // higher is better balance
  return { score, recommendation: score < 0.6 ? 'rebalance' : 'balanced' };
}
